import { render, staticRenderFns } from "./AlphaOrderStatusModal.vue?vue&type=template&id=73132cdc"
import script from "./AlphaOrderStatusModal.vue?vue&type=script&lang=js"
export * from "./AlphaOrderStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports